import { render, staticRenderFns } from "./AgenciesSingleCoordinatorsListItem.vue?vue&type=template&id=1f3a1fdf&"
import script from "./AgenciesSingleCoordinatorsListItem.vue?vue&type=script&lang=js&"
export * from "./AgenciesSingleCoordinatorsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports